module.exports = __webpack_public_path__ + "img/germany-cervical-cancer-female.47c34d76.png";